module.exports = __webpack_public_path__ + "img/calendar.8b079e47.svg";